import { Component, Input } from '@angular/core';

@Component({
  selector: 'sb-support-text-block',
  templateUrl: './sb-support-text-block.component.html',
})
export class SbSupportTextBlockComponent {
  @Input()
  title: string;

  @Input()
  body: string;
}
